<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16C7XIh/tc-custom/9781609452179.jpg?1718106413350" alt="This image is the cover for the book By My Hand, The Commissario Ricciardi Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">By My Hand, The Commissario Ricciardi Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The fifth Commissario Ricciardi historical mystery in the series of “ingenious crime novels, written with intelligence and enthusiasm” (<i>The Wall Street Journal</i>).</b><br/><br/>As Naples prepares for its holiday celebrations, behind the facade of order and happiness imposed by the fascist regime, lurks terrible poverty and blinding desperation. In a luxurious apartment on the Mergellina beach the bodies of a fascist militia officer and his wife have been found. The woman has had her throat cut while the man has been stabbed over sixty times. Seemingly, the hands of two separate killers have been at work. A statuette of San Giuseppe, patron saint of workers, lies in pieces on the floor. At the scene of the crime, Ricciardi, who has the dubious gift of being able to see and hear the last seconds in the lives of those who have suffered a violent death, listens to the enigmatic last words of the couple. Accompanied by his faithful partner Brigadier Raffaele Maione, and once more troubled by two women who compete for his attentions, the Commissario will have to trace a wide and frenetic arc through the streets of Naples in order to uncover the truth.<br/><br/>“The refreshing lack of cynicism of de Giovanni’s two lead detectives, Brigadier Raffaele Maione and Commissario Luigi Alfredo Ricciardi, distinguishes the quietly enjoyable fifth Commissario Ricciardi mystery set in 1930s Naples. . . . Engaging characters and melancholy atmosphere.” —<i>Publishers Weekly</i><br/><br/>“One of the most entrancing series of crime novels.” —<i>Shots Magazine</i><br/><br/>“An absolutely terrific series.” —Open Letters Monthly
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maurizio de Giovanni, Antony Shugaar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df38b222